export default __webpack_public_path__ + "static/media/capsule-landing-token-chainlink.54544ca2.png";